import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const UserFullName = ({changeNameOrCareerReducer, user}) => {

    useEffect(() => {}, [changeNameOrCareerReducer]);

    const capitalizeCustom = (data) => {
      if (data) {
        return data.toLowerCase().charAt(0).toUpperCase() + data.toLowerCase().slice(1)
      }
      return "";
    }

    const capitalizeFirstName = (firstName) => {
        if (firstName) {
          let nombre = "";
          const nameSplitted = firstName.toLowerCase().split(" ");
            nameSplitted.forEach(name => {
              nombre += " " + capitalize(name);
          });
          return nombre;
        }
        return "";
    }
    
    const capitalize = (value) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    return (
        <div>
          { capitalizeFirstName(user.persona.nombre) } {' '}
          { capitalizeCustom(user.persona.primerApellido) } {' '}
          { capitalizeCustom(user.persona.segundoApellido) }
        </div>
    );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    changeNameOrCareerReducer: state.changeNameOrCareerReducer,
  }
}

export default connect(mapStateToProps)(UserFullName);
